import React from 'react'
import {useAppSelector} from '../../store/hooks'
import {selectDisplayName, selectHasGroup} from '../../store/userSlice'
import {
  useGetAccountsQuery,
  useListLeaseApplicationsQuery
} from '../../services/residentPortalApi'
import {GroupType} from '../../types/app-types'
import AppLayout from '../layout/AppLayout'
import LeaseApplicationListCard from './LeaseApplicationListCard'
import AccountListCard from './AccountListCard'

const HomePage = () => {
  const userName = useAppSelector(selectDisplayName)
  const isResident = useAppSelector(selectHasGroup(GroupType.Resident))
  const isLeaseApplicant = useAppSelector(
    selectHasGroup(GroupType.LeaseApplicant)
  )
  const accountsQuery = useGetAccountsQuery(undefined, {skip: !isResident})
  const leaseApplicationsQuery = useListLeaseApplicationsQuery(undefined, {
    skip: !isLeaseApplicant
  })

  return (
    <AppLayout>
      <h1 className="text-md sm:text-2xl font-bold mb-4">
        Welcome, {userName}!
      </h1>
      <div className="flex flex-col md:flex-row gap-2 w-full">
        {isResident ? <AccountListCard accountsQuery={accountsQuery} /> : ''}

        {isLeaseApplicant ? (
          <LeaseApplicationListCard
            leaseApplicationsQuery={leaseApplicationsQuery}
          />
        ) : (
          ''
        )}
      </div>
    </AppLayout>
  )
}

export default HomePage
